import React from "react"
import { AppRouteProps } from "@harea/component"

const PaymentLicensesContainer = React.lazy(() => import("./container/PaymentLicensesContainer"))

export const LicensesRoutes: Array<AppRouteProps> = [
    {
        path: "product-licenses",
        element: <PaymentLicensesContainer />,
        roles: ["BACKOFFICE"],
        title: "Harea.Billing.Licenses.Title",
    },
    {
        path: "product-licenses/create",
        element: <PaymentLicensesContainer />,
        roles: ["BACKOFFICE"],
        title: "std_create_license",
    },
]
